import type { RewardListResponse, RewardResponse } from '@ping/api';

export type RewardStatus = 'cancelled' | 'claimed' | 'available' | 'scheduled';

const normalizeApiRewardStatus = (rewardStatus?: string | null): string =>
  typeof rewardStatus === 'string' ? rewardStatus.trim().toLowerCase() : '';

export const isRewardClaimableNow = (claimableAt?: string | null): boolean => {
  if (!claimableAt) {
    return true;
  }

  return new Date(claimableAt).getTime() <= Date.now();
};

export const getRewardStatus = (reward: RewardResponse): RewardStatus => {
  if (normalizeApiRewardStatus(reward.rewardStatus) === 'cancelled') {
    return 'cancelled';
  }

  if (reward.isClaimed) {
    return 'claimed';
  }

  if (isRewardClaimableNow(reward.claimableAt)) {
    return 'available';
  }

  return 'scheduled';
};

export const isRewardClaimable = (reward: RewardResponse): boolean => getRewardStatus(reward) === 'available';

export const hasUnclaimedRewards = (rewards?: RewardListResponse | null): boolean =>
  rewards?.items?.some(reward => {
    const status = getRewardStatus(reward);
    return status === 'available' || status === 'scheduled';
  }) ?? false;

export const pickRewardForBanner = (rewards?: RewardListResponse | null): RewardResponse | undefined => {
  const items = rewards?.items;
  if (!items?.length) {
    return undefined;
  }

  const claimableNow = items.find(isRewardClaimable);
  return claimableNow ?? items.find(reward => getRewardStatus(reward) === 'scheduled');
};
